<template>
	<v-card elevation="5" class="mt-3 text-left pa-3" :style="dialog ? 'margin-top:15px; !important' : ''">
		<div class="font-weight-bold mb-2">{{ $t('scoring-audit') }}</div>
		<div class="font-weight-medium font-size13">{{ $t('audit-list-1') }}</div>
		<div class="font-weight-medium font-size13">{{ $t('audit-list-2') }}</div>
		<div class="font-weight-medium font-size13">{{ $t('audit-list-3') }}</div>
	</v-card>
</template>

<script>
export default { name: 'AlcoholScreeningQuestionnaire', props: ['dialog'] };
</script>
